import { css } from '@emotion/react';
import { Color } from "../../constants/";

export const useStyles = (props) => ({
  deviceLimitContainer: css({
    position: "relative",
    width: "100%",
    height: 435,
    backgroundColor: Color.neutral[100],
    boxSizing: "border-box",
    padding: "16px 24px 16px 24px",
  }),
  deviceLimitTypographyNumber: css({
    letterSpacing: -1.7,
  }),
  deviceLimitTypographyCapacity: css({
    marginLeft: 6,
    marginTop: 12,
    width: 50,
  }),
  deviceLimitShowMoreHorizontal: css({
    position: "absolute",
    top: 20,
    right: 20,
    color: Color.primary[500],
    cursor: "pointer",
  }),
});
